import Api from '@/services/Index';

const getAll = (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/staff/cards', config);
}

const printCard = (id, side = "") => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/staff/cards/print/' + id + `?side=${side}`, {responseType: 'arraybuffer'});
}

const createCard = (id, side = "") => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    const params = { side };
    return Api.get('/staff/cards/create/' + id, { responseType: 'arraybuffer', params });
}

const updateFobNumber = (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/staff/cards/fob-number/' + id, formData);
}

export default {
    getAll,
    printCard,
    createCard,
    updateFobNumber
}
